import { useParams } from 'react-router-dom';
import styles from './styles.module.css';

import { useQuery } from '@tanstack/react-query';

import { BiUser } from 'react-icons/bi';
import {
    IoRibbonOutline, IoTimeOutline,
    IoCalendarOutline, IoArrowDownCircleOutline,
    IoAlertCircleSharp
} from 'react-icons/io5';
import { BsCashCoin } from 'react-icons/bs';


import { Spinner, Error as MyError } from 'src/Components';
import BASE_URL, { levels, levelsType } from 'src/constants/vars';
import useScrollToTop from 'src/hooks/useScrollToTop';


function Detail() {
    const params = useParams();

    const featchCourse = async () => {
        const res = await fetch(`${BASE_URL}/courses/${params.id}`);
        if (res.status === 404) {
            throw new Error('لم يتم العثور على الكورس')
        }
        const jsonData = await res.json();
        return jsonData
    }

    useScrollToTop();


    const { data, error, isLoading, isError, isFetching, status } = useQuery({ queryKey: ['courseRetrieveData'], queryFn: () => featchCourse() })

    if (isError) {
        let msg: string = "حدث خطأ ما"
        if (error instanceof Error) {
            msg = error.message;
        }
        return <MyError msg={msg} icon={IoAlertCircleSharp} iconColor={'#1c8eb1'} />
    }
    return (
        <article className={styles.article}>
            <div className='container'>
                <div className='row'>
                    {isLoading || isFetching ?
                        <Spinner width={80} height={80} />
                        :
                        data !== undefined ?

                            <>
                                <div className='col-12 col-lg-8'>
                                    <div className='post-detail'>
                                        <div className={styles.imgCon}>
                                            <img src={data.image} alt={data.name}
                                                height={400} width={"100%"} />
                                        </div>
                                        <div className={styles.content}>

                                            <div className={styles.cats}>
                                                {data.categories.map((item: any) => (
                                                    <div key={`cat-${item.id}`}>
                                                        {item.title}
                                                    </div>
                                                ))}


                                            </div>
                                            <div className={styles.title}>
                                                <h4>
                                                    {data.name}
                                                </h4>
                                            </div>
                                            {data.instructor !== null && data.instructor !== undefined &&
                                                <div className={styles.ins}>
                                                    <div className={styles.icon}>
                                                        <BiUser size={20} />
                                                    </div>
                                                    المدرب \
                                                    {data.instructor}
                                                </div>
                                            }

                                            <div className={styles.text} dangerouslySetInnerHTML={{ __html: data.content }}>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12 col-lg-4'>

                                    <div className='row'>
                                        <div className='col-lg-12 col-md-6'>
                                            <div className={styles.myCard}>
                                                <div className={styles.title}>
                                                    <h4>
                                                        نبذ عن الدورة
                                                    </h4>
                                                </div>
                                                <div className={styles.info}>
                                                    <div>
                                                        <div className={styles.icon}>
                                                            <IoRibbonOutline size={20} />
                                                        </div>
                                                        <div className={styles.text}>
                                                            {levels[data.level as keyof levelsType]}
                                                        </div>
                                                    </div>
                                                    {data.duration !== null && data.duration !== undefined &&
                                                        <div>
                                                            <div className={styles.icon}>
                                                                <IoTimeOutline size={20} />
                                                            </div>

                                                            <div className={styles.text}>
                                                                {data.duration}
                                                            </div>

                                                        </div>
                                                    }
                                                    <div>
                                                        <div className={styles.icon}>
                                                            <IoCalendarOutline size={20} />
                                                        </div>
                                                        <div className={styles.text}>
                                                            {data.start_date} {data.end_date ? <span className='t-primary'> - </span> : ''} {data.end_date}
                                                        </div>
                                                    </div>
                                                    {data.price !== null && data.price !== undefined &&
                                                        data.price > 0 &&
                                                        <div>
                                                            <div className={styles.icon}>
                                                                <BsCashCoin size={20} />
                                                            </div>

                                                            <div className={`${styles.text}`}>
                                                                {data.price}
                                                                {" "}
                                                                د.ل
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className={styles.btnCon}>
                                                    <a href={data.link}>
                                                        تسجيل
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-12 col-md-6'>
                                            <div className={`${styles.myCard} mt-lg-4`}>
                                                <div className={styles.title}>
                                                    <h4>
                                                        ملفات مرفقة
                                                    </h4>
                                                </div>
                                                <div className={styles.files}>

                                                    {data.files.map((item: any) => (
                                                        <a href={item.file} key={`file-${item.id}`}>
                                                            <div className={styles.text}>
                                                                {item.name}
                                                            </div>
                                                            <div className={styles.icon}>
                                                                <IoArrowDownCircleOutline size={25} />
                                                            </div>
                                                        </a>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </>
                            : null

                    }
                </div>
            </div>
        </article>
    )
}

export default Detail